import React from 'react';
import PropTypes from 'prop-types';
import IndustryInfo from '@/business-components/sale/IndustryInfo';
import AreaInfo from '@/business-components/sale/AreaInfo';
import PromotedObjectInfo from '@/business-components/sale/PromotedObjectInfo';
import ExternalLink from '@/components/ExternalLink';
import MpOpenInfo from '@/components/MpOpenInfo';
import LinkButton from '@/components/LinkButton';
import WithPermission from '@/common/permissions/WithPermission';
import Delegate from '@/components/Delegate';
import AccountDetail from '@/pages/orders/AccountDetail';
import AttributionTeam from '@/business-components/sale/AttributionTeam';
import { leadStatusMap, REACT_APP_PUBLIC_URL, LEAD_LAYER_TYPE, BUDGET_TYPE } from '@/constants/Constants';
import perms from '@/common/permissions/sale/perms';
import { withApi } from '@tencent/react-aio';
import DateTime from '@/components/DateTime';
import UserInfo from '@/business-components/sale/UserInfo';
import OrderStatus from '@/business-components/sale/OrderStatus';
import { renderFollowOperator } from '@/utils/ColumnRender';
import _ from 'lodash';
import { OverlayTrigger, PopOver } from '@tencent/spaui';
import Icon from '@tencent/od-icon';
import { RenderLeadPromoteExperience } from '@/business-components/sale/LeadPromoteExperienceSelect';

class OrderPanel extends React.PureComponent {
  static propTypes = {
    lead: PropTypes.shape({
      leadId: PropTypes.number.isRequired,
      company: PropTypes.shape({
        companyName: PropTypes.string.isRequired,
        industryId: PropTypes.number.isRequired,
        areaId: PropTypes.number.isRequired,
        address: PropTypes.string,
      }).isRequired,
      intention: PropTypes.shape({
        adPlatformType: PropTypes.string.isRequired,
        promotedObject: PropTypes.string,
      }),
      memo: PropTypes.string,
      customerId: PropTypes.number,
      customerMpUserName: PropTypes.string,
      customerUnibdAppId: PropTypes.string,
    }).isRequired,
    readOnly: PropTypes.bool,
    onEdit: PropTypes.func,
  }

  constructor(props) {
    super(props);

    this.accountDetail = React.createRef();
  }

  componentDidMount() {
    this.getLeadStatus();
  }

  showAccountDetailModal = (tickedId) => {
    this.accountDetail.current.show({
      tickedId,
    });
  }

  getLeadStatus = () => {
    const {
      webApi,
      lead: { relatedLeadId },
    } = this.props;
    if (relatedLeadId) {
      webApi
        .getLeadStatus(relatedLeadId)
        .ajax()
        .then((res) => {
          if (res) {
            this.setState({
              linkUrl: leadStatusMap[res.progressStatus],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  linkToDetail = () => {
    const {
      lead: { relatedLeadId },
    } = this.props;
    const { linkUrl } = this.state;
    if (linkUrl && relatedLeadId) {
      window.location.href = `${window.location.origin}${REACT_APP_PUBLIC_URL}/${linkUrl}/${relatedLeadId}`;
    }
  }

  render() {
    const {
      readOnly,
      lead: {
        leadId,
        company,
        intention,
        memo,
        relatedLeadId,
        createdTime,
        leadPromote,
        competitorTags,
        leadNewStore,
        leadLayerType,
        operationTags,
        budgetAmount,
        originalCustomerId,
      },
      onEdit,
      ascriptionTeamId,
      ascriptionOwnerId,
      detail: { taskProvideTime, followOperatorList, orderStatus, onlineSalesTags = [] },
    } = this.props;
    const followOperator = renderFollowOperator('', '', followOperatorList);

    return (
      <div className="CustomerPanel">
        <h1>
          {company.companyName}
          <IndustryInfo industryId={company.industryId} />
          <WithPermission reject={readOnly} oneOf={[perms.LEAD_EDIT_SELF, perms.LEAD_EDIT_GROUP, perms.LEAD_EDIT_ALL, perms.POTENTIAL_EDIT_SELF, perms.POTENTIAL_EDIT_GROUP, perms.POTENTIAL_EDIT_ALL]}>
            <LinkButton onClick={onEdit}>编辑</LinkButton>
          </WithPermission>
        </h1>
        <dl>
          <dt>线索 ID：</dt>
          <dd>{leadId}</dd>
          <dt>公司地址：</dt>
          <dd>
            <AreaInfo areaCode={company.areaId} /> {company.address}
          </dd>
          <dt>关联线索 ID：</dt>
          <dd>
            <a href="javascript:;" onClick={this.linkToDetail}>
              {relatedLeadId}
            </a>
          </dd>
          <dt>公司官网：</dt>
          <dd>
            <ExternalLink href={company.homepageUrl} />
          </dd>
          <dt>推广目标：</dt>
          <dd>
            <PromotedObjectInfo promotedObject={intention} />
          </dd>
          <dt>公众号名称：</dt>
          <dd>
            {company.mpOpenName}
            {/* <MpOpenInfo mpOpenName={company.mpOpenName} /> */}
          </dd>
          <dt>跟进销售：</dt>
          <dd>
            <div>
              <UserInfo key={ascriptionOwnerId} userId={ascriptionOwnerId} />
            </div>
          </dd>
          <dt>所属团队：</dt>
          <dd>
            <div>
              <AttributionTeam ownerId={ascriptionOwnerId} ascriptionTeamId={ascriptionTeamId} />
            </div>
          </dd>
          <dt>跟进运营：</dt>
          <dd>
            <div>{followOperator}</div>
          </dd>
          <dt>状态：</dt>
          <dd>
            <div>
              <OrderStatus orderStatus={orderStatus} />
            </div>
          </dd>
          <dt>线索导入时间：</dt>
          <dd>
            <DateTime dateTime={createdTime} />
          </dd>
          <dt>任务发放时间：</dt>
          <dd>
            <DateTime dateTime={taskProvideTime} />
          </dd>
          <dt>是否推广：</dt>
          <dd>
            <div>{leadPromote ? '是' : '否'}</div>
          </dd>
          <dt>推广经验：</dt>
          <dd>
            <RenderLeadPromoteExperience value={competitorTags} />
          </dd>
          <dt>是否新店：</dt>
          <dd>
            <div>{leadNewStore ? '是' : '否'}</div>
          </dd>
          <dt>线索分层：</dt>
          <dd>
            <div>{LEAD_LAYER_TYPE[leadLayerType]}</div>
          </dd>
          <dt>备注信息：</dt>
          <dd>
            <div>{memo}</div>
          </dd>
          <dt>运营标签：</dt>
          <dd>
            {operationTags?.map((item) => (
              <div style={{ display: 'flex', alignItems: 'center' }} key={item.leadTagId}>
                {item.leadTagName}
                <OverlayTrigger
                  overlay={<PopOver>{item.memo}</PopOver>}
                  placement='right'
                  alignment='bottom'
                >
                  <Icon name="help-filled" color="#14A3F5" style={{ width: 14, height: 14, marginLeft: 5, cursor: 'pointer' }} />
                </OverlayTrigger>
              </div>
            ))}
          </dd>
          <dt>留资客户预算：</dt>
          <dd>
            <div>{budgetAmount ? BUDGET_TYPE[budgetAmount] : ''}</div>
          </dd>
          <dt>留资客户账户：</dt>
          <dd>
            <div>{originalCustomerId}</div>
          </dd>
          {/* <dt>企微标签：</dt>
          <dd>
            <div>{_.isArray(onlineSalesTags) ? onlineSalesTags.join(",") : null}</div>
          </dd>
          */}
        </dl>
        <Delegate ref={this.accountDetail} component={AccountDetail} />
      </div>
    );
  }
}

export default withApi(OrderPanel);
